/* yl-v10.js · Homepage v10 (3 Oct 2026)
   Three small behaviours, no libraries:
   1. Play in place: a still is a button; pressing it puts the film into the same frame
      (youtube-nocookie). Nothing is fetched from YouTube before the press. Close or
      Escape puts the still back and returns focus to it. One film at a time.
   2. The phone menu drawer: opens and closes, Escape, focus kept inside while open.
   3. The IST clock in the footer (when the footer shows it). */
(function () {
  if (window.__y10) return;
  window.__y10 = true;

  /* ---------------------------------------------------------------- play */
  var current = null;   // { frame, button, player }

  function stop(returnFocus) {
    if (!current) return;
    var c = current;
    current = null;
    if (c.player && c.player.parentNode) c.player.parentNode.removeChild(c.player);
    c.frame.classList.remove('is-playing');
    if (returnFocus !== false) { try { c.button.focus({ preventScroll: true }); } catch (e) { c.button.focus(); } }
  }

  function play(button) {
    var id = button.getAttribute('data-y10-play');
    var frame = button.closest('[data-y10-frame]');
    if (!id || !frame) return;
    stop(false);
    var player = document.createElement('div');
    player.className = 'y10-player';
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'y10-player__close';
    close.textContent = 'Close ✕';
    close.setAttribute('aria-label', 'Close the film');
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    f.title = button.getAttribute('data-y10-title') || 'Film';
    f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    f.setAttribute('allowfullscreen', '');
    player.appendChild(f);
    player.appendChild(close);
    frame.appendChild(player);
    frame.classList.add('is-playing');
    current = { frame: frame, button: button, player: player };
    close.addEventListener('click', function () { stop(true); });
    try { close.focus({ preventScroll: true }); } catch (e) { close.focus(); }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-y10-play]');
    if (b) { e.preventDefault(); play(b); return; }
    var t = e.target.closest && e.target.closest('[data-y10-play-target]');
    if (t) {
      var target = document.getElementById(t.getAttribute('data-y10-play-target'));
      if (target) { e.preventDefault(); play(target); }
    }
  });

  /* ---------------------------------------------------------------- menu */
  var openBtn = null;

  function drawer() { return document.getElementById('y10-drawer'); }

  function openMenu(btn) {
    var d = drawer(); if (!d) return;
    openBtn = btn;
    d.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    var first = d.querySelector('a, button');
    if (first) first.focus();
  }

  function closeMenu() {
    var d = drawer(); if (!d || d.hidden) return;
    d.hidden = true;
    document.documentElement.style.overflow = '';
    if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); }
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-y10-menu]');
    if (o) { e.preventDefault(); openMenu(o); return; }
    if (e.target.closest && e.target.closest('[data-y10-menu-close]')) { e.preventDefault(); closeMenu(); return; }
    var d = drawer();
    if (d && !d.hidden && e.target.closest && e.target.closest('#y10-drawer a')) closeMenu();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = drawer();
      if (d && !d.hidden) { closeMenu(); return; }
      if (current) stop(true);
      return;
    }
    if (e.key === 'Tab') {
      var dr = drawer();
      if (!dr || dr.hidden) return;
      var items = dr.querySelectorAll('a, button');
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------------------------------------------------------- clock */
  function tick() {
    var els = document.querySelectorAll('[data-y10-ist]');
    if (!els.length) return;
    var t;
    try {
      t = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date());
    } catch (e) { return; }
    Array.prototype.forEach.call(els, function (el) { el.textContent = t; });
  }
  tick();
  setInterval(tick, 30000);
})();
